import { datadogRum } from '@datadog/browser-rum';

export default defineNuxtPlugin(() => {
  const { ddApplicationId, ddApplicationToken, nuxtEnv } =
    useRuntimeConfig().public;
  if (nuxtEnv === 'development') return;

  datadogRum.init({
    applicationId: ddApplicationId,
    clientToken: ddApplicationToken,
    site: 'datadoghq.eu',
    service: 'career-website',
    env: nuxtEnv,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'allow',
  });
});
